exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tagsList[data-v-87cebe78]{position:relative;padding-right:5px}.tagsList .tags-list-order-label-tag[data-v-87cebe78]{position:sticky;top:0;padding-bottom:10px;background:#fff;z-index:10}", ""]);

// exports
